import { collection, getDocs, doc, getDoc, setDoc, updateDoc, deleteDoc, query, where } from 'firebase/firestore'
import { db } from '@lib/firebase'

// PRODUCTS
export const getProducts = async (activeOnly = false) => {
  try {
    const productsRef = collection(db, 'products')
    let q = productsRef
    if (!activeOnly) {
      q = query(productsRef, where('active', '==', true))
    }
    const productSnapshot = await getDocs(q)
    return productSnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }))
  } catch (err) {
    console.error(err)
    throw err
  }
}

export const getProduct = async id => {
  const productRef = doc(db, 'products', id)
  const productSnap = await getDoc(productRef)

  if (productSnap.exists()) {
    return {
      id: productSnap.id,
      ...productSnap.data(),
    }
  } else {
    return null
  }
}

export const createProduct = async (id, product) => {
  try {
    const productRef = doc(db, 'products', id)
    await setDoc(productRef, product)
  } catch (err) {
    console.error(err)
    throw err
  }
}

export const updateProduct = async (id, product) => {
  try {
    const productRef = doc(db, 'products', id)
    await updateDoc(productRef, product)
  } catch (err) {
    console.error(err)
    throw err
  }
}

export const deleteProduct = async id => {
  try {
    const productRef = doc(db, 'products', id)
    await deleteDoc(productRef)
  } catch (err) {
    console.error(err)
    throw err
  }
}

export const toggleProductStatus = async (id, currentStatus) => {
  try {
    const productRef = doc(db, 'products', id)
    await updateDoc(productRef, { active: !currentStatus })
  } catch (err) {
    console.error(err)
    throw err
  }
}

// OFFERS

export const getOffers = async (activeOnly = false) => {
  try {
    const offersRef = collection(db, 'offers')
    let q = offersRef
    if (activeOnly) {
      q = query(offersRef, where('active', '==', true))
    }
    const querySnapshot = await getDocs(q)
    return querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }))
  } catch (error) {
    console.error('Error fetching offers:', error)
    throw error
  }
}

export const createOffer = async offer => {
  try {
    const offerRef = doc(db, 'offers', offer.id)
    await setDoc(offerRef, offer)
  } catch (error) {
    console.error('Error creating offer:', error)
    throw error
  }
}

export const updateOffer = async (id, offerData) => {
  try {
    const offerRef = doc(db, 'offers', id)
    await updateDoc(offerRef, offerData)
  } catch (error) {
    console.error('Error updating offer:', error)
    throw error
  }
}

export const deleteOffer = async id => {
  try {
    const offerRef = doc(db, 'offers', id)
    await deleteDoc(offerRef)
  } catch (error) {
    console.error('Error deleting offer:', error)
    throw error
  }
}

export const toggleOfferStatus = async (id, currentStatus) => {
  try {
    const offerRef = doc(db, 'offers', id)
    await updateDoc(offerRef, { active: !currentStatus })
  } catch (error) {
    console.error('Error toggling offer status:', error)
    throw error
  }
}
